import script from "./SwitchMode.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchMode.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchMode.vue?vue&type=style&index=0&id=1cf23a48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf23a48"]])

export default __exports__